import { Box } from "@chakra-ui/react"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import Slider from "react-slick"
import "../../utils/slick-theme.css"
import "../../utils/slick.css"

import {
  ArrowLeft,
  ArrowRight,
} from "@giraldomac/gatsby-theme-wvumedicine/src/components/elements/"

const ImageCarousel = ({images}) => {
  const settings = {
    adaptiveHeight: "true",
    arrows: true,
    dots: true,
    padding: "3em",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <ArrowLeft />,
    nextArrow: <ArrowRight />,
  }

  
  return (
    <Slider {...settings}>
      {images?.map(({ ...image }) => (
        <Box key={image?.filename} px={[6, 6, 9]}>
          
              <GatsbyImage
                image={image.gatsbyImageData}
                alt={`slide`}
                sx={{
                  objectFit: "cover",
                }}
              />
            </Box>
            
      ))}
    </Slider>
  )
}

export default ImageCarousel
